var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#5C6E7D;stroke-width:1.5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,22.3c-0.2,0-0.5,0-0.6-0.2c-0.6-0.2-0.9-0.6-1.4-1.1l-0.2-0.2c-0.6-0.9-1.2-0.9-1.9,0l-0.2,0.2 c-0.3,0.6-0.9,0.9-1.4,1.1c-0.5,0.2-0.9,0.2-1.5-0.3l-1.5-0.9C6,20.6,5.7,20,5.5,19.4c-0.2-0.8-0.2-1.4,0.3-2c0-0.6,0-1.1-0.2-1.4 c-0.2-0.3-0.6-0.5-1.1-0.5c-1.2,0-2.5-1.1-2.5-2.6v-1.7c0-1.4,1.1-2.6,2.5-2.6c0.6,0,0.9-0.2,1.1-0.5C5.8,8,5.8,7.5,5.5,7.2 c-0.3-0.8-0.3-1.5-0.3-2c0.2-0.8,0.6-1.2,1.1-1.5l1.5-0.9c1.1-0.8,2.5-0.3,3.1,0.9l0.2,0.2c0.6,0.9,1.2,0.9,1.9,0l0.2-0.2 C13.7,2.6,15,2.1,16,2.7l1.5,0.9c0.6,0.3,1.1,0.9,1.1,1.5c0.2,0.8,0.2,1.4-0.3,2c-0.3,0.6-0.3,0.9-0.2,1.2c0.2,0.3,0.6,0.5,1.1,0.5 c1.2,0,2.5,1.1,2.5,2.6v1.7c0,1.4-1.1,2.6-2.5,2.6c-0.6,0-1.1,0.2-1.1,0.5c-0.2,0.3-0.2,0.8,0.2,1.2c0.3,0.6,0.5,1.2,0.3,2 c-0.2,0.8-0.6,1.2-1.1,1.5L16,22C15.9,22.2,15.6,22.3,15.3,22.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.2,16.1c-2.2,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9s3.9,1.7,3.9,3.9S14.3,16.1,12.2,16.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.9312bf972b720c0b218479ae7ecaba9a.svg";
export { ForwardRef as ReactComponent };